import React, { useState, useMemo, useContext, useReducer } from 'react';
import { Form } from 'semantic-ui-react';
import request from 'services/http';
import produce from 'immer';

import { tap } from 'rxjs/operators';
import { useSubscription, toQuery } from 'utils';
import ReactInputMask from 'react-input-mask';
import { GlobalContext } from 'globalContext';
import { DateTime } from 'luxon';

const initialState = {
    data_ini: '',
    data_fim: '',
    bico: '',
    produto: '',
    empresa: '',
};

function formReducer(state, action) {
    switch (action.type) {
        case 'reset':
            return initialState;

        case 'payload':
            return state;

        default:
            return { ...state, ...action.payload };
    }
}

export default function FormularioPesquisa({ handleData, cleanup }) {
    const [products, setProducts] = useState([]);

    const [form, setForm] = useReducer(formReducer, initialState);

    const [{ empresas }] = useContext(GlobalContext);
    const companies =
        empresas
            ?.filter((companie) => companie.tipo === 'POSTO')
            .sort((a, b) => {
                if (a.nomeEmpresa > b.nomeEmpresa) {
                    return 1;
                }

                if (a.nomeEmpresa < b.nomeEmpresa) {
                    return -1;
                }
                return 0;
            }) ?? [];

    companies.unshift({
        _id: 0,
        nomeEmpresa: 'TODOS OS POSTOS',
    });

    const getProducts = useMemo(
        () =>
            request({ method: 'GET', url: '/combustivel/produto' }).pipe(
                tap(({ response }) => {
                    setProducts([{ id: 0, nome: 'Todos Produtos' }, ...response]);
                }),
            ),
        [],
    );
    useSubscription(getProducts);

    function handleSelectChange(e, { name, value }) {
        setForm({ payload: { [name]: value } });
    }

    function handleInputChange(event) {
        if (event.target) {
            const { name, value } = event.target;
            return setForm({ payload: { [name]: value } });
        }
    }

    const handleSearch = () => {
        produce(form, (draft) => {
            const sendData = draft;

            if (!sendData.data_ini && sendData.data_fim) {
                sendData.data_ini = sendData.data_fim;
                sendData.data_fim = '';
            }

            if (sendData.data_ini !== '')
                sendData.data_ini = DateTime.fromFormat(sendData.data_ini, 'dd/MM/yyyy').toFormat(
                    'yyyy-MM-dd',
                );
            if (sendData.data_fim !== '')
                sendData.data_fim = DateTime.fromFormat(sendData.data_fim, 'dd/MM/yyyy').toFormat(
                    'yyyy-MM-dd',
                );

            handleData(toQuery(sendData));
        });
    };

    const handleCleanup = () => {
        setForm({ type: 'reset' });
        cleanup();
    };

    return (
        <div>
            <Form className="search-form">
                <Form.Group>
                    <Form.Field width="3">
                        <label>Produto</label>
                        <Form.Select
                            search
                            name="produto"
                            value={form.produto}
                            onChange={handleSelectChange}
                            placeholder="Selecione um produto"
                            selectOnBlur={false}
                            options={products?.map((product) => ({
                                key: product.id,
                                value: product.id,
                                text: product.nome,
                            }))}
                        />
                    </Form.Field>

                    <Form.Field width="3">
                        <label>Empresa</label>
                        <Form.Select
                            search
                            name="empresa"
                            value={form.empresa}
                            onChange={handleSelectChange}
                            placeholder="Selecione uma empresa"
                            selectOnBlur={false}
                            options={companies?.map((companie) => ({
                                key: companie._id,
                                value: companie._id,
                                text: `${companie.nomeEmpresa}`,
                            }))}
                        />
                    </Form.Field>

                    <Form.Field width="3">
                        <label>Data aferição (período)</label>
                        <Form.Input
                            children={
                                <ReactInputMask
                                    value={form.data_ini}
                                    mask="99/99/9999"
                                    name="data_ini"
                                    onChange={handleInputChange}
                                    placeholder="Data inicial"
                                />
                            }
                        />
                    </Form.Field>

                    <Form.Field width="3">
                        <label>&nbsp;</label>
                        <Form.Input
                            children={
                                <ReactInputMask
                                    value={form.data_fim}
                                    mask="99/99/9999"
                                    name="data_fim"
                                    onChange={handleInputChange}
                                    placeholder="Data final"
                                />
                            }
                        />
                    </Form.Field>

                    <Form.Field width="3">
                        <label>Bico (serie)</label>
                        <Form.Input
                            name="bico"
                            value={form.bico}
                            onChange={handleInputChange}
                            placeholder="Nº série do bico"
                        />
                    </Form.Field>

                    <Form.Field width="2">
                        <Form.Button
                            disabled={
                                form.data_ini === '' &&
                                form.data_fim === '' &&
                                form.bico === '' &&
                                (form.produto === '' || form.produto === 0) &&
                                form.empresa === ''
                            }
                            label="&nbsp;"
                            content="Buscar"
                            icon="search"
                            onClick={() => handleSearch()}
                        />
                    </Form.Field>

                    <Form.Field width="2">
                        <Form.Button
                            disabled={
                                form.data_ini === '' &&
                                form.data_fim === '' &&
                                form.bico === '' &&
                                form.produto === '' &&
                                form.empresa === ''
                            }
                            label="&nbsp;"
                            content="Limpar"
                            icon="trash"
                            onClick={() => handleCleanup()}
                        />
                    </Form.Field>
                </Form.Group>
            </Form>
        </div>
    );
}
